import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import QueryKeys from '@src/constants/queryKeys';
import useDeviceMutations from '@src/hooks/api/mutations/useDeviceMutations';
import { useQueryClient } from '@tanstack/react-query';
import { Dispatch, SetStateAction } from 'react';

interface DialogProps {
  deviceIds: string[];
  setOpen: Dispatch<SetStateAction<boolean>>;
  onCancel: () => void;
  onSuccess?: () => void;
}

function DeleteMultipleDevicesDialog({
  deviceIds,
  setOpen,
  onCancel,
  onSuccess,
}: DialogProps) {
  const queryClient = useQueryClient();
  const { deleteMultipleDevices } = useDeviceMutations();

  const handleMultipleDevicesDelete = () =>
    deleteMultipleDevices.mutate(
      { ids: deviceIds },
      {
        onSuccess: async () => {
          const invalidations = [
            queryClient.invalidateQueries({
              queryKey: [QueryKeys.devices],
            }),
            queryClient.invalidateQueries({
              queryKey: [QueryKeys.widgetDeviceList],
            }),
          ];
          await Promise.all(invalidations);
          setOpen(false);
          onSuccess?.();
        },
      },
    );

  return (
    <Dialog open>
      <DialogContent>
        <FormattedAlias
          id='Are you sure you want to delete {count} device(s)?'
          values={{ count: deviceIds.length }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          <FormattedAlias id='Cancel' />
        </Button>
        <Button
          size='small'
          variant='contained'
          onClick={handleMultipleDevicesDelete}
          disabled={deleteMultipleDevices.isPending}
        >
          <FormattedAlias id='Confirm' />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteMultipleDevicesDialog;
